module.exports = __webpack_public_path__ + "img/face39.b65dba32.gif";